import { initializeApp, type FirebaseApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, type Auth } from "firebase/auth";
import { getFirestore, type Firestore } from "firebase/firestore";
import { localAuthBypassEnabled } from "./local-development";

const required = (key: string): string => {
  const v = import.meta.env[key];
  if (!v) {
    if (localAuthBypassEnabled()) return `local-${key.toLowerCase()}`;
    throw new Error(`Missing ${key}. Did you copy .env.example to .env.local and fill it in?`);
  }
  return v;
};

const config = {
  apiKey: required("VITE_FIREBASE_API_KEY"),
  authDomain: required("VITE_FIREBASE_AUTH_DOMAIN"),
  projectId: required("VITE_FIREBASE_PROJECT_ID"),
  appId: required("VITE_FIREBASE_APP_ID"),
};

export const firebaseApp: FirebaseApp = initializeApp(config);
export const auth: Auth = getAuth(firebaseApp);
export const db: Firestore = getFirestore(firebaseApp);
export const googleProvider = new GoogleAuthProvider();
